module.exports = __webpack_public_path__ + "media/play-track.gif";